import React from 'react'
import { Modal, Card, Icon, Spin, message } from 'antd'

const { Meta } = Card

const ModeSelectionModal = ({
  visible,
  onSelectMode,
  onCancel,
  isSavingVideoData,
  videoId
}) => {
  const showPreparingLoading = isSavingVideoData && !videoId

  const showError = () => {
    message.error('Please wait while the video workspace is prepared...')
  }

  return (
    <Modal
      visible={visible}
      title="Select Creation Mode"
      onCancel={onCancel}
      footer={null}
      centered
      width={700}
      className="mode-selection-modal"
      // AntD v3: Prevent closing while backend is creating the record
      closable={!showPreparingLoading}
      maskClosable={!showPreparingLoading}
    >
      <Spin spinning={showPreparingLoading} tip="Preparing video workspace...">
        <div
          style={{
            display: 'flex',
            gap: '24px',
            padding: '20px',
            justifyContent: 'center',
            // Visual feedback & blocking interaction
            opacity: showPreparingLoading ? 0.6 : 1,
            pointerEvents: showPreparingLoading ? 'none' : 'auto',
            transition: 'all 0.3s'
          }}
        >
          <Card
            hoverable
            style={{ width: 300 }}
            onClick={() => (videoId ? onSelectMode('manual') : showError())}
          >
            <div
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                fontSize: '48px',
                color: '#1890ff'
              }}
            >
              <Icon type="ordered-list" />
            </div>
            <Meta
              title="Manual Mode"
              description="Create your video step-by-step. Full control over every scene, precise edits, and detailed customization as you go."
            />
          </Card>

          <Card
            hoverable
            style={{ width: 300 }}
            onClick={() => (videoId ? onSelectMode('draft') : showError())}
          >
            <div
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                fontSize: '48px',
                color: '#52c41a'
              }}
            >
              <Icon type="rocket" />
            </div>
            <Meta
              title="Draft Mode"
              description="Fast-track your setup. Configure everything on one screen while AI generates shots in the background."
            />
          </Card>
        </div>
      </Spin>
    </Modal>
  )
}

export default ModeSelectionModal
